export default "/static/media/icon-paperplane.d6d390c0.svg";